import React, { useState } from 'react';

import { useAcknowledgeEventDateModel } from '@hooks/API/Event/UseEvent';
import { useUpdateFollowupAcknowledgment } from '@hooks/API/Event/UseFollowup';
import { useUpdateTravelAcknowledgment } from '@hooks/API/Event/UseTravel';

import MiniLoading from '@components/Gui/MiniLoading';
import { NwButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const AcknowledgementEvent = ({
    eventId,
    button,
    type,
    previewMode,
    acknowledgmentValue,
    eventDateModelID,
    onStatusChanged,
}) => {
    const [isLoading, setLoading] = useState(false);
    const { mutateAsync: onUpdateTravelAcknowledgment } = useUpdateTravelAcknowledgment();
    const { mutateAsync: onUpdateFollowupAcknowledgment } = useUpdateFollowupAcknowledgment();
    const { mutateAsync: onAcknowledgeEventDateModel } = useAcknowledgeEventDateModel();

    const onUpdateAcknowledgment = async () => {
        let endpoint = '';
        switch (type.toLowerCase()) {
            case 'extjob':
                return null;
            case 'travel':
                await onUpdateTravelAcknowledgment({ ID: eventId });
                break;
            case 'followup':
                await onUpdateFollowupAcknowledgment({ ID: eventId });
                break;
            case 'meeting':
                break;
            case 'casting':
            case 'job':
            case 'ext':
                const acknowledge = acknowledgmentValue === 'NotChecked' ? 'Checked' : 'NotChecked';
                await onAcknowledgeEventDateModel({
                    eventDateModelId: eventDateModelID,
                    acknowledge: acknowledge,
                    eventId: eventId,
                });
                break;
            default:
                return null;
        }
        return endpoint;
    };

    const changeAcknowledgement = async (e) => {
        if (!previewMode) {
            setLoading(true);
            e.stopPropagation();
            try {
                await onUpdateAcknowledgment();
                if (onStatusChanged) {
                    await onStatusChanged();
                }
                setLoading(false);
            } catch (error) {
                console.error('error', error);
                setLoading(false);
            }
        }
    };

    const getStyleIcon = { fontSize: '1.5rem', opacity: acknowledgmentValue === 'NotChecked' ? '.25' : '1' };
    const color = acknowledgmentValue !== 'NotChecked' ? StyleVariables.SuccessColor : StyleVariables.GreyedColor;

    return button ? (
        <NwButton
            tooltip={
                acknowledgmentValue !== 'NotChecked'
                    ? 'Click here to remove the acknowledgement'
                    : 'Click here to mark as acknowledged'
            }
            loading={isLoading}
            icon={byPrefixAndName.fass['check']}
            onClick={changeAcknowledgement}
            iconOpacity={acknowledgmentValue !== 'NotChecked' ? 1 : 0.25}
            className={acknowledgmentValue !== 'NotChecked' ? 'event-acknowledged-button' : ''}
        />
    ) : isLoading ? (
        <MiniLoading />
    ) : (
        <NwIcon
            onClick={changeAcknowledgement}
            style={getStyleIcon}
            icon={byPrefixAndName.fass['check']}
            color={color}
        />
    );
};
export default AcknowledgementEvent;
